import {
  Bridge,
  BridgeAction,
  BridgePayload,
  BridgePayloadMap,
} from "./Bridge";
import { Logger } from "../utils/Logger";

export class FlutterBridge extends Bridge {
  readonly platform = "flutter";

  protected postMessage(action: BridgeAction, payload?: BridgePayload) {
    if (typeof window === "undefined") {
      Logger.error("window is undefined", {
        tags: { from: "FlutterBridge.postMessage" },
      });
      return;
    }

    if (window.Blux?.postMessage) {
      window.Blux.postMessage(JSON.stringify({ action, payload }));
      return;
    }

    if (window.flutter_inappwebview?.callHandler) {
      window.flutter_inappwebview
        .callHandler("Blux", JSON.stringify({ action, payload }))
        .catch((err) =>
          Logger.error(err, { tags: { from: "FlutterBridge.postMessage" } }),
        );
      return;
    }

    Logger.error("No Flutter WebView available", {
      tags: { from: "FlutterBridge.postMessage" },
    });
  }

  initialize(payload: BridgePayloadMap["initialize"]) {
    this.postMessage("initialize", payload);
  }

  signIn(payload: BridgePayloadMap["signIn"]) {
    this.postMessage("signIn", payload);
  }

  signOut() {
    this.postMessage("signOut");
  }

  setUserProperties(payload: BridgePayloadMap["setUserProperties"]) {
    this.postMessage("setUserProperties", payload);
  }

  setCustomUserProperties(
    payload: BridgePayloadMap["setCustomUserProperties"],
  ) {
    this.postMessage("setCustomUserProperties", payload);
  }

  sendEvent(payload: BridgePayloadMap["sendEvent"]) {
    this.postMessage("sendEvent", payload);
  }
}
